import DashboardLayout from '@/app/layouts/DashboardLayout';
import { AccountsProvider } from '@accounts';
import DashboardSections from './DashboardSections';

export default function DashboardPage() {
  return (
    <AccountsProvider>
      <DashboardLayout>
        <DashboardSections />
      </DashboardLayout>
    </AccountsProvider>
  );
}
